// src/pages/About.js
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { useParams } from "react-router-dom"
import { paymentInvoice } from "helpers/fakebackend_helper"
import Invoice from "components/invoice"


const PaymentInvoice = (props) => {
  const { id } = useParams() // 👈 get id from URL
  const [invoice, setInvoice] = useState({ inv: [], mauth_id: {} })
  useEffect(() => {
    if (id) {
      paymentInvoice(id).then(res => {
        const processingData = []
        res.inv.map((t,idx) => {
          t.processingData = {
            price: t.price,
            discount: t.discount 
          }
        })
        // res.inv.
        
        setInvoice(res)
       }).catch(err => console.log("err", err))
    }
  }, [id])
  return (
    <>
    
      <Invoice processData={invoice.mauth_id} invoiceItems={invoice.inv} invoiceData={invoice} isPublic={true} />
    </>
  )
}

PaymentInvoice.propTypes = {
}

export default withRouter(PaymentInvoice)
